import { render, staticRenderFns } from "./AuthenticateButton.vue?vue&type=template&id=2db4ad8e&scoped=true&"
import script from "./AuthenticateButton.vue?vue&type=script&lang=js&"
export * from "./AuthenticateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db4ad8e",
  null
  
)

export default component.exports